import { render } from "./PlatFormVideo.vue?vue&type=template&id=1fff3134&scoped=true"
import script from "./PlatFormVideo.vue?vue&type=script&lang=js"
export * from "./PlatFormVideo.vue?vue&type=script&lang=js"

import "./PlatFormVideo.vue?vue&type=style&index=0&id=1fff3134&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1fff3134"]])

export default __exports__